import React from 'react';

const ToPeso = ({ amount }) => {
  // Calculate the payment progress
  const converted = parseFloat(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return (
    <>
    ₱{converted}
    </>
  );
};

export default ToPeso;
